import { message } from "antd";
import { showErrorToast } from "V2.0/utils";

function getLifecycleCbs(onInit, onSuccess, onError) {
  function init() {
    message.loading("Updating Follow Ups");
    onInit();
  }

  function success() {
    message.destroy();
    message.success("Follow Ups Updated");
    onSuccess();
  }

  function error(e) {
    message.destroy();
    showErrorToast(e, "Failed to update follow ups");
    onError();
  }

  return {
    init,
    success,
    error,
  };
}

export { getLifecycleCbs };
